import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() sidebarStatusEmit: EventEmitter<boolean> = new EventEmitter();
  public sidebarStatus: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Toggles sidebarStatus and emits changes
   */
  public toggleMenu(): void {
    this.sidebarStatus = !this.sidebarStatus;
    this.sidebarStatusEmit.emit(this.sidebarStatus);
  }

}
